import BasePostGrid from "@PegasusCore/pegasus-one-post-grid/src/script.js";

export class PostGrid extends BasePostGrid { 
    constructor() {
        super();
    }

    hasActiveFilters() {
        return Object.keys(this.currentFilters || {}).length > 0;
    }

    getBaseUrl() {
        return window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    }

    prepareFeaturedPostForFetch() {
        const featuredPost = this.$el.querySelector('[data-featured-post]');
        if (!featuredPost) {
            return;
        }

        featuredPost.classList.add('transition-opacity', 'duration-200');

        if (this.hasActiveFilters()) {
            featuredPost.classList.remove('hidden');
            featuredPost.classList.add('opacity-40');
        } else {
            featuredPost.classList.remove('opacity-40');
        }
    }

    waitForFetchComplete(callback) {
        let frames = 0;
        const maxFrames = 240;

        const check = () => {
            if (!this.isLoading || frames >= maxFrames) {
                callback();
                return;
            }

            frames += 1;
            requestAnimationFrame(check);
        };

        requestAnimationFrame(check);
    }

    fetchContent(href = null) {
        this.prepareFeaturedPostForFetch();
        this.syncPatternVisibility();
        super.fetchContent(href);

        this.waitForFetchComplete(() => {
            this.syncFeaturedPostVisibility();
            this.syncPatternVisibility();
        });
    }

    syncFeaturedPostVisibility() {
        const featuredPost = this.$el.querySelector('[data-featured-post]');
        if (!featuredPost) {
            return;
        }

        const hasActiveFilters = this.hasActiveFilters();
        featuredPost.classList.remove('opacity-40');
        featuredPost.classList.toggle('hidden', hasActiveFilters);
    }

    syncPatternVisibility() {
        const patternRows = this.$el.querySelectorAll('.Post__Grid__pattern');
        if (!patternRows.length) {
            return;
        }

        const hasActiveFilters = this.hasActiveFilters();
        patternRows.forEach((patternRow) => {
            patternRow.classList.toggle('hidden', hasActiveFilters);
        });
    }

    init() {
        super.init();
        this.syncFeaturedPostVisibility();
        this.syncPatternVisibility();

        // Listen for filter events dispatched by the PostFilter block
        window.addEventListener('pegasus-post-filter-toggle', (event) => {
            const firstPostGrid = document.querySelector('.Post__Grid[x-data]');
            if (firstPostGrid !== this.$el) {
                return;
            }

            this.currentFilters = { ...(event.detail.currentFilters || {}) };
            this.fetchContent(this.hasActiveFilters() ? null : this.getBaseUrl());
        });

        // Activate the first filter by default if "Show All" is hidden
        // Ensure filters exist and hide_show_all is true
        if (this.filters && this.filters.length > 0 && this.hide_show_all) {
            const firstFilter = this.filters[0];
            const filterKey = this.getPrefixedFilter(firstFilter.taxonomy, 'taxonomy');

            // Only set it if no filter is active yet
            if (!this.currentFilters[filterKey]) {
                this.currentFilters[filterKey] = firstFilter.slug;
            }
        }
    }

    toggleFilters(term = '', filterName = '', type = 'taxonomy'){
        const filter = this.getPrefixedFilter(filterName, type);

        if (this.currentFilters[filter] === term) {
            delete this.currentFilters[filter];
        } else {
            Object.keys(this.currentFilters).forEach(key => delete this.currentFilters[key]);
            this.currentFilters[filter] = term;
        }

        this.fetchContent(this.hasActiveFilters() ? null : this.getBaseUrl());
    }

    /**
     * loadMore
     * 
     * Description: Loads the next page of posts below the current set of posts.
     * @return void
     */   
    loadMore(){

        // Get the post grid container and the data selector for the post grid.
        const postGrid = this.$root.querySelector('[data-pegasus-filterable]');
        const dataSelector = '[data-pegasus-filterable="'+postGrid.dataset.pegasusFilterable+'"]';

        // Get the url for the next page of posts. This is taken from the href of the load more button.
        const href = this.$el.getAttribute("href");

        // Get the container and elements to be loaded from the next page.
        const container = [dataSelector];
        const elements = ['[data-pegasus-single-card]', '.Post__Grid-next-page'];

        // Only allow the load more button to be clicked whilst we're not waiting for a response.
        if(!this.isLoading){
            this.isLoading = true;

            // Run the loadMoreContent function from pegasus.
            pegasus.loadMoreContent(href, container, elements, {}, () => {
                this.isLoading = false;

                // Remove the load more button from the original page, 
                // keeping only the one that comes back from the request.
                this.$el.parentElement.remove();

                // Re-initialize modal triggers for newly loaded content
                if (window.allModals && typeof window.allModals === 'function') {
                    window.allModals().init();
                }
            });
        }

    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('postGrid', () => new PostGrid());
});
